import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { RegistrationRequest } from '../models/registration-request.model';
import { ApiService, ParamList } from './api.service';
import { WorkOrderStatus, WorkOrderType } from '../models/work-order.model';

@Injectable()
export class RegistrationRequestService {
    public BaseUrl = '/api/registrations';

    constructor(public http: HttpClient,
        public apiService: ApiService) { }

    get(): Observable<Array<RegistrationRequest>> {
        return this.http.get<Array<RegistrationRequest>>(`${this.BaseUrl}`);
    }

    find(statuses: WorkOrderStatus[], templateIds: string[], types: WorkOrderType[]): Observable<Array<RegistrationRequest>> {
        const params = [
            new ParamList('statuses', statuses),
            new ParamList('templateIds', templateIds),
            new ParamList('types', types)
        ];
        const url = `${this.BaseUrl}/find` + this.apiService.buildParameterList(params);
        return this.http.get<Array<RegistrationRequest>>(url);
    }
}
